<template>
  <div class="achievement-list">
    <!-- <el-checkbox-group
      class="checkbox-group"
      v-model="checkList"
      @change="gradeAchievementChange"
    >
      <achievementItem
        v-for="(item, index) in gradeExamInfoList"
        :key="index"
        :itemType="'grade'"
        @viewClassExam="viewClassExam"
        @chartDialogShow="chartDialogShow"
        @jumpStudentRank="jumpStudentRank"
        :examInfo="item"
      />
    </el-checkbox-group> -->
    <el-table :data="gradeExamInfoList" border :cell-style="{ 'text-align': 'center' }"
      :header-cell-style="{ 'background-color': '#0066cc', 'color': '#fff', 'text-align': 'center' }"
      style="width: 98%; margin: 0 auto;" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="gradeName" label="年级"> </el-table-column>
      <el-table-column prop="title" label="主标题"> </el-table-column>
      <el-table-column prop="subTitle" label="副标题" width="150"> </el-table-column>
      <el-table-column prop="startTime" label="开始时间" width="150"> </el-table-column>
      <el-table-column prop="endTime" label="结束时间" width="150"> </el-table-column>
      <el-table-column prop="schoolYear" label="学年"> </el-table-column>
      <el-table-column prop="semester" label="学期">
        <template slot-scope="scope">
          {{ scope.row.semester == "1" ? "第一学期" : "第二学期" }}
        </template>
      </el-table-column>
      <el-table-column prop="rankUpdateTime" label="排名更新时间" width="180">
        <template slot-scope="scope">
          {{ scope.row.rankUpdateTime ? scope.row.rankUpdateTime : "未更新" }}
        </template>
      </el-table-column>
      <el-table-column prop="isExternal" label="是否对外">
        <template slot-scope="scope">
          {{ scope.row.isExternal == "0" ? "否" : "是" }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="480" fixed="right">
        <template slot-scope="scope">
          <div class="handle-container">
            <el-button type="warning" size="small" @click.stop="viewClassExam(scope.row)"
              v-hasPermi="'sc:classexam:query'">班级考试 </el-button>
            <!-- <el-button type="success" size="small" @click.stop="jumpStudentRank(scope.row)" v-hasPermi="'sc:gradescore:rank'">学生排行 </el-button> -->
            <el-button type="success" size="small" @click.stop="jumpStudentRank(scope.row)"
              v-hasPermi="'sc:achievement:analysis'">成绩分析 </el-button>
            <el-button type="success" size="small" @click.stop="viewDimension(scope.row)"
              v-hasPermi="'sc:gradeexam:latitude'">查看维度 </el-button>
            <el-button type="success" size="small" @click.stop="tableShowSwitch(scope.row)"
              v-hasPermi="'sc:gradeexam:latitude'">维度图例 </el-button>
            <el-button type="primary" size="small" @click.stop="rankingUpdate(scope.row)"
              v-hasPermi="'sc:rank:update'">排名更新 </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <achievementChartDialog v-show="chartShow" :chartShow.sync="chartShow" :tableData="tableData" />
    <dimensionTableDialog v-show="dimensionTableShow" :examInfo="examInfo" :descList="descList"
      :dimensionTableShow.sync="dimensionTableShow" :tableData="tableData" />
  </div>
</template>

<script>
import achievementItem from "@/components/achievement-item/achievementItem.vue";
import achievementChartDialog from "../achievement-chart-dialog/achievementChartDialog.vue";
import dimensionTableDialog from "../dimension-table-dialog/dimensionTableDialog.vue";

export default {
  props: ["gradeExamInfoList", "courseFullList", "searchData"],
  components: { achievementItem, achievementChartDialog, dimensionTableDialog },
  data() {
    return {
      checkList: [],
      gradeExamData: {}, // 年级考试信息
      chartShow: false,
      tableData: [], // 维度数据
      dimensionTableShow: false, // 维度表格显示
      descList: [], // 动态的维度列表
      examInfo: {},
    };
  },
  created() { },
  inject: ["refresh"],
  methods: {
    // 排名更新
    rankingUpdate(data) {
      this.get(`${this.$url.rankingUpdate}/${data.id}`).then((res) => {
        if (res.code !== 200)
          return this.$message.error(res.msg || "成绩未录入");
        this.$message.success(res.msg || "更新成功");
        this.refresh();
      });
    },
    // 查看维度图例
    tableShowSwitch(e) {
      // 查询维度数据
      this.getDimensionData(e, 'chart');
    },
    viewDimension(e) {
      this.examInfo = e;
      // 查询维度数据
      this.getDimensionData(e, 'table');
      this.dimensionTableShow = true;
    },
    // 查询维度数据
    getDimensionData(e, text) {
      this.descList = [];
      const data = {
        examInfoId: e.id,
        gradeId: e.gradeId,
      };
      this.post(this.$url.selectExamDimensionDetails, data)
        .then((res) => {
          if (res.code !== 200) {
            return;
          }
          this.tableData = res.data;
          this.tableData.forEach((cItem) => {
            if (cItem.descList && cItem.descList.length > 0) {
              cItem.descList.forEach((item) => {
                if (!this.descList.find((dItem) => dItem.desc === item.desc)) {
                  this.descList.push(item);
                }
              });
            };
          });

          if (text !== 'chart') return;

          // 检测数据中是否有指标数据
          let isEveryDescListEmpty = this.tableData.every(
            (item) => item.descList.length === 0
          );

          if (isEveryDescListEmpty) {
            // 所有的 descList 数组都为空
            return this.$message.warning("未录入指标");
          } else {
            // 至少有一个 descList 数组不为空
            // this.gradeExamData = this.tableData;
            this.chartShow = true;
          }
        })
        .catch((error) => {
          // 处理错误
          console.error("Error:", error);
        });
    },
    handleSelectionChange(e) {
      // 使用filter()方法去除undefined和null
      let filteredArray = e.filter((item) => {
        return item !== undefined && item !== null;
      });

      let examIdArray = [];
      filteredArray.forEach((item) => {
        examIdArray.push(item.id);
      });

      this.$emit("gradeAchievementChange", examIdArray);
    },
    // 跳转学生排行(年级)
    jumpStudentRank(data) {
      // this.$router.push({
      //   path: "/achievement-student-rank",
      //   query: {
      //     examType: 'grade',
      //     examInfo: JSON.stringify(data),
      //     searchData: JSON.stringify(this.searchData)
      //   },
      // });
      this.$router.push({
        path: "/achievement-analysis",
        query: {
          examInfo: JSON.stringify(data),
          searchData: JSON.stringify(this.searchData)
        },
      });
    },
    // 点击查看班级考试
    viewClassExam(data) {
      this.$emit("viewClassExam", data);
    },
    // 柱状图显示
    // chartDialogShow(data) {
    //   // 检测数据中是否有指标数据
    //   const isEveryDescListEmpty = data.every(
    //     (item) => item.descList.length === 0
    //   );

    //   if (isEveryDescListEmpty) {
    //     // 所有的 descList 数组都为空
    //     return this.$message.warning("未录入指标");
    //   } else {
    //     // 至少有一个 descList 数组不为空
    //     this.gradeExamData = data;
    //     this.chartShow = true;
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
@import "./achievementList.scss";
</style>